module.exports = __webpack_public_path__ + "static/media/Artboard18.adb1585c.png";